module.exports = __webpack_public_path__ + "img/03n.1c0b6295.png";